<template>
  <div class="page-content" style="margin: 0px; width: 100%">
    <PageHeader></PageHeader>
    <Main
        v-if="$route.name === names.MAIN"
        :name_list='left_menu_list'
    ></Main>
    <router-view v-else></router-view>
  </div>
</template>

<script>

import names from "@/modules/admin/routers/names"
import Main from "./Main";
import {getInstMenu, getInstNameByRouterName} from "@/helper/instances";
import PageHeader from "../menus/PageHeader";
import {mapActions, mapGetters} from "vuex";
import {checkIsDevelopmentServer} from "@/helper";


export default {
  name: "AdminBase",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: {Main, PageHeader},
  data(){
    return {
      left_menu_list: [
        {title: "Главная", icon: "home", color: "#90CAF9", included: false, router: {name:  names.MAIN, params:{}}},
        {title: "Заявки", icon: "grading", color: "#90CAF9", included: true, router: {name:  names.ORDERS.LIST, params:{}}},
        {
          title: "Справочники", icon: "view_quilt", subs: [
            {title: "Посетители", icon: "groups", color: "#76b5c5", included: true, router: {name:  names.VISITORS.LIST, params:{}}},
            {title: "Автомобили", icon: "drive_eta", color: "#76b5c5", included: true, router: {name: names.CARS.LIST, params:{}}},
            {title: "Организации", icon: "corporate_fare", color: "#76b5c5", included: true, router: {name: names.ORGANIZATIONS.LIST, params:{}}}
          ]
        },
        {
          title: "Настройки", icon: "view_quilt", subs: [
            {title: "Роли", icon: "manage_accounts", color: "#eab676", included: true, router: {name: names.ROLES.LIST, params:{}}},
            {title: "Заместители", icon: "people_alt", color: "#eab676", included: true, router: {name: names.REPLACEMENTS.LIST, params:{}}},
            {title: "Заблокированные пользователи", icon: "no_accounts", included: true, color: "#eab676", router: {name: names.BANS.LIST, params:{}}},
            {title: "Посты охраны", icon: "camera_outdoor", color: "#eab676", included: true, router: {name: names.GUARD_POSTS.LIST, params:{}}},
            // {title: 'Поля сведений', icon: 'edit_note', color: '#eab676', included: true, router: {name:  names.FIELDS.LIST, params:{}}},
            {title: "Чаты", icon: "chat", included: true, color: "#eab676", router: {name: names.CHATS.LIST, params:{}}},
            {title: "Выгрузки файлов", icon: "source", included: true, color: "#eab676", router: {name: names.FILE.LIST, params:{}}}
          ]
        }
        // {title: 'Статистика', icon: 'bar_chart', included: true, router: {name:  names.STATISTICS.MAIN, params:{}}},
      ]
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: "user/isAuthenticate",
      isMobileView: "isMobileView"
    })
  },
  methods: {
    checkIsDevelopmentServer: checkIsDevelopmentServer,
    ...mapActions({
      connectJWT: "eventchain/connectJWT",
      initEvent: "eventchain/initEvent"
    }),
    loadLeftmenu() {
      this.$store.commit("mainpage/changeTitle", "Администратор");
      if (this.isAuthenticated) {
        this.$store.commit("leftmenu/replaceInstances", getInstMenu());
        this.$store.commit("leftmenu/selectInstance", getInstNameByRouterName(names.MAIN));
        this.$store.commit("leftmenu/replaceItems", this.getLeftMenu());
      } else {
        this.$store.commit("leftmenu/dissable");
      }
    },
    getLeftMenu() {
      let menu = []
      for (let el in this.left_menu_list){
        menu.push(this.left_menu_list[el])
      }
      return menu
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.loadLeftmenu()
    next()
  },
  created() {
    if (this.isAuthenticated) {
      this.$store.commit("leftmenu/enableLeftMenu");
      if (!this.isMobileView) this.$store.commit("leftmenu/showLeftMenu");
    }
    if (checkIsDevelopmentServer()) {
      this.connectJWT({
        finalizer: () => {
          this.initEvent({})
        }
      })
    }
    this.loadLeftmenu()
  }
}
</script>

<style scoped>

</style>
